import CoachTable from './CoachTable';

export default CoachTable;
